import type React from 'react';

import { cn } from '@change/ds-utils';

import { useSkeletonContext } from '../context/LoadingSkeletonContext';
import type { SkeletonShapeProps } from '../types';

import { CircleStyles } from './Circle.styles';

export const Circle: React.FC<SkeletonShapeProps> = (props) => {
	const { className = '', size, loading: loadingProp } = props;

	const { loading, shapeSize, shapeColorClassName } = useSkeletonContext();

	const resolvedLoading = loadingProp ?? loading;
	const resolvedSize = size || shapeSize;
	const mergedClassName = cn(shapeColorClassName, className);

	const styles = CircleStyles({ loading: resolvedLoading, size: resolvedSize, class: mergedClassName });

	return <div data-shape="circle" className={styles} />;
};
